function Tabs() {
	var self = this;
	self.init();
}

Tabs.prototype.init = function() {
	var self = this;
	$('.tabs-container .tabs-container-link').click(function() {
		var id = $(this).attr('data-for');
			target = $(this).closest('.tabs-container').find('.tabs-container-items > *[data-id="'+id+'"]');
		$(this).addClass('-active').siblings().removeClass('-active');		
		target.addClass('-active').siblings().removeClass('-active');
		target.find('.slick-slider').slick('refresh');
	});
};